'use strict';

/**
 * Creates Lpm payment instance
 * @param {Promise} clientInstancePromise Braintree client instance promise
 * @returns {Promise} A promise resolved with the Lpm instance
 */
function createLpmPayment(clientInstancePromise) {
    return clientInstancePromise
        .then(function(btClientInstance) {
            return braintree.localPayment.create({
                client: btClientInstance
            });
        });
}

/**
 * Creates and returns object with all options for initiating the LPM payment flow
 * @param {Object} shippingData Order Shipping address
 * @param {Object} lpmConfigs LPM configs object
 * @param {string} paymentMethodName Payment method name
 * @param {string} email Email address
 * @param {number} amount Order total amount
 * @returns {Object} Options object
 */
function createRequestData(shippingData, lpmConfigs, paymentMethodName, email, amount) {
    const helper = require('../../helper');

    const billingAddress = JSON.stringify(helper.createBillingAddress());
    const recipientName = shippingData.recipientName.split(' ');

    shippingData.firstName = recipientName[0];
    shippingData.lastName = recipientName[1];

    return {
        paymentType: paymentMethodName,
        amount: amount,
        fallback: {
            url: `${lpmConfigs.fallbackUrl}?lpmName=${paymentMethodName}&email=${email}&billing=${billingAddress}`,
            buttonText: 'Complete Payment'
        },
        currencyCode: lpmConfigs.options.currency,
        shippingAddressRequired: false,
        email: email,
        phone: shippingData && shippingData.phone,
        givenName: shippingData && shippingData.firstName,
        surname: shippingData && shippingData.lastName,
        address: {
            countryCode: shippingData && shippingData.countryCode
        }
    };
}

/**
 *
 * @param {lpmInstance} localPaymentInstance LPM instance
 * @param {Object} reqData Options object
 * @returns {Promise} Promise resolved with a startPaymentPayload
 */
function startPayment(localPaymentInstance, reqData) {
    return localPaymentInstance.startPayment(reqData);
}

module.exports = {
    createLpmPayment,
    createRequestData,
    startPayment
};
